import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper";
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";
import Checkbox from "../../../../../components/common/Checkbox/Checkbox";

const ChatRoles = () => {
  const data = [
    { role: "Administrator" },
    { role: "Inventory Manager" },
    { role: "Order Processor" },
    { role: "Customer Service" },
    { role: "Marketing Manager" },
  ];

  const columns = [
    { name: "Role", selector: (row) => row.role, minWidth: "160px" },
    { name: "Manage Chat Users", cell: () => <Checkbox />, center: true, minWidth: "180px" },
    { name: "Edit Messages", cell: () => <Checkbox />, center: true, minWidth: "160px" },
    { name: "Delete Messages", cell: () => <Checkbox />, center: true, minWidth: "160px" },
    { name: "Mute Users", cell: () => <Checkbox />, center: true, minWidth: "160px" },
    { name: "View Chat History", cell: () => <Checkbox />, center: true, minWidth: "160px" },
    { name: "Chat Setting", cell: () => <Checkbox />, center: true, minWidth: "160px" },
  ];

  return (
    <YellowHeaderWrapper title={"Role and Permissions"}>
      <DatatableComponent columns={columns} data={data} type={"gray"} />
    </YellowHeaderWrapper>
  );
};

export default ChatRoles;